import { useMutation } from '@tanstack/react-query';
import { createSupportRequest } from '@uplift/api';


export const useCreateSupportRequestMutation = () => {
  return useMutation({
    mutationFn: async ({ supportTypeId, problemText }: { problemText: string; supportTypeId: string }) => {
      return createSupportRequest(supportTypeId, problemText);
    }
  });
};
